import { Component, OnInit, ViewChild } from '@angular/core';
import { UserData } from '../models/user-data.model';
import { UserRoles } from '../models/user-roles.model';
import { UserMgmtService } from '../user-mgmt-service/user-mgmt-service.service';

import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { map } from 'rxjs/operators';

export class ListItems {
  uid: string;
  userData: UserData;
  userRoles: UserRoles;
}


@Component({
  selector: 'app-user-mgmt-list',
  templateUrl: './user-mgmt-list.component.html',
  styleUrls: ['./user-mgmt-list.component.scss']
})
// tslint:disable-next-line:component-class-suffix
export class UserMgmtList implements OnInit {

  combinedList: ListItems[] = [];
  loading = true;

  userMgmts$: Observable<UserData[]>;
  userRoles$: Observable<UserRoles[]>;

  @ViewChild(MatSort, {static: true}) sort: MatSort;



  displayedColumns = ['userLastName', 'userEmail', 'userPhone', 'reguser', 'employee', 'sysadmin', 'edit', 'delete'];
  dataSource: MatTableDataSource<any>;

  constructor(
    public userMgmtService: UserMgmtService,
    private router: Router,
    public dialog: MatDialog) { }

  ngOnInit() {

    this.userMgmts$ = this.userMgmtService.getAllUsers().pipe(
      map(items => {
      // console.log('Value Changes has returned in the list of users (component) !!', items);

      return items;
    }));    // observable of userMgmts data

    this.userRoles$ = this.userMgmtService.getAllRoles().pipe(
      map(items => {
      // console.log('Value Changes has returned in the list of user roles (component) !!', items);
      return items;
    }));    // observable of userRoles data

    this.userMgmts$.subscribe(items => {
      // console.log('subscribe has returned in the list of users (component) !!', items);
      // this.combinedList = []; // reset the array
      for (const it of items) {
        let NotHereAlready = true;
        for (const ex of this.combinedList) {
          if (ex.uid === it.uid) {
            NotHereAlready = false;
            ex.userData = it;
          }
        }
        if (NotHereAlready) {
          const tempEx = new ListItems();
          tempEx.uid = it.uid;
          tempEx.userData = it;
          this.combinedList.push(tempEx);
        }
      }
      // check for deletions
      if (items.length !== this.combinedList.length) {
        // Need to delete the missing record from this.combinedItems
        this.combinedList.forEach((ex, index) => {
          let ThisOneIsMissing = true;
          for (const it of items) {
            if (ex.uid === it.uid) {
              ThisOneIsMissing = false;
            }
          }
          if (ThisOneIsMissing) {
            this.combinedList.splice(index, 1);
          }
        });
      }
    });

    this.userRoles$.subscribe(items => {
      // console.log('subscribe has returned in the list of user roles (component) !!', items);
      for (const it of items) {
        let NotHereAlready = true;
        for (const ex of this.combinedList) {
          if (ex.uid === it.uid) {
            NotHereAlready = false;
            ex.userRoles = it;
          }
        }
        if (NotHereAlready) {
          const tempEx = new ListItems();
          tempEx.uid = it.uid;
          tempEx.userRoles = it;
          this.combinedList.push(tempEx);
        }
      }
      // console.log('Combined list has been built and it is: ', this.combinedList);
      this.loading = false;
      this.dataSource = new MatTableDataSource(this.combinedList);
      this.dataSource.sort = this.sort;

      // This is where I do my custome sorting !!
      this.dataSource.sortingDataAccessor = (item, property) => {

        // console.log('In the sorting Data Accessor - when does this happen ??')
        // console.log('What is the item ??: ', item);
        // console.log('What is the property ??: ', property);
        // return item[property];

        switch (property) {
          case 'userLastName': return item.userData.userLastName;
          case 'userEmail': return item.userData.userEmail;
          case 'userPhone': return item.userData.userPhone;
          case 'reguser': return item.userRoles.reguser;
          case 'employee': return item.userRoles.employee;
          case 'sysadmin': return item.userRoles.sysadmin;
          default: return item[property];
        }
      };

    });

  }

  trackByUid(index, item) {
    return item.uid;
  }

  // createNewUserMgmt() {

  //   this.router.navigate(['/admin', this.userMgmtService.createNewUser()]);
  // }

  addUserRolesObject(forThisId: string) {
    this.userMgmtService.createNewUserRoles(forThisId);
  }

  deleteTheUserMgmt(theIdToBeDeleted: string) {
    console.log('In user managment deleting user with id ' + theIdToBeDeleted);
    this.userMgmtService.deleteUserData(theIdToBeDeleted);

  }

  giveRegUserPerms(id: string) {
    console.log('Giving user id ' + id + ' Regular User Permissions !');
    this.userMgmtService.updateUserRoles(id, { 'reguser': true });
  }
  recindRegUserPerms(id: string) {
    console.log('Recinding user id ' + id + '\'s Regular User Permissions !');
    this.userMgmtService.updateUserRoles(id, { 'reguser': false });
  }

  // async addEmployeeToList(userRecord: any) {
  //   const newRecord = new EmployeeModel();
  //   newRecord.uid = userRecord.uid;
  //   if (userRecord.userData.userDisplayName !== '') {
  //     newRecord.name = userRecord.userData.userDisplayName;
  //   } else {
  //     newRecord.name = userRecord.userData.userFirstName + ' ' + userRecord.userData.userLastName;
  //   }
  //   newRecord.email = userRecord.userData.userEmail;
  //   await this.employeeListService.addEmployeeToList(newRecord);
  // }

  async giveEmployeePerms(userRecord: any) {
    console.log('Giving user id ' + userRecord.uid + ' Employee Permissions !');
    const rtnResult = await this.userMgmtService.updateUserRoles(userRecord.uid, { 'employee': true });
    console.log('the return result is: ', rtnResult);

    if (rtnResult === 'success') {

      // add user to employees list
      // await this.addEmployeeToList(userRecord);

    } else {
      console.log('error updating permission trying to give employee perms');
    }
  }

  async recindEmployeePerms(userRecord: any) {
    console.log('Recinding user id ' + userRecord.uid + '\'s Employee Permissions !');
    const rtnResult = await this.userMgmtService.updateUserRoles(userRecord.uid, { 'employee': false });
    console.log('the return result is: ', rtnResult);

    if (rtnResult === 'success' && userRecord.userRoles.sysadmin === false) {
      // add user to employees list
      // await this.employeeListService.removeEmployeeFromList(userRecord.uid);
    } else {
      console.log('error updating permission trying to recind employee perms');
    }
  }

  async giveSysAdminPerms(userRecord: any) {
    console.log('Giving user id ' + userRecord.uid + ' Sys Admin Permissions !');
    const rtnResult = await this.userMgmtService.updateUserRoles(userRecord.uid, { 'sysadmin': true });

    console.log('the return result is: ', rtnResult);
    if (rtnResult === 'success') {

      // add user to employees list
      // await this.addEmployeeToList(userRecord);

    } else {
      console.log('error updating permission trying to give sysAdmin perms');
    }
  }
  async recindSysAdminPerms(userRecord: any) {
    console.log('Recinding user id ' + userRecord.uid + '\'s Sys Admin Permissions !');
    const rtnResult = await this.userMgmtService.updateUserRoles(userRecord.uid, { 'sysadmin': false });
    console.log('the return result is: ', rtnResult);

    if (rtnResult === 'success' && userRecord.userRoles.employee === false) {
      // add user to employees list
      // await this.employeeListService.removeEmployeeFromList(userRecord.uid);
    } else {
      console.log('error updating permission trying to recind sysAdmin perms');
    }
  }

}
